import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import classes from './pages.module.css';
import { Container } from "react-bootstrap";
import LinkList from "../components/Ui/block/linkList";
import logo from '../image/pt_bg.png';
import iconIot from '../image/icon_iot.png';
import iconDesign from '../image/icon_design.png';
import iconMedia from '../image/icon_media.png';
import iconSec from '../image/icon_sec.png';
import iconMon from '../image/icon_mon.png';
import iconControl from '../image/icon_control.png';
import linkImg from '../image/tele_bg.jpeg';
import image1 from '../image/carousel/image1.jpeg';
import image2 from '../image/carousel/image2.jpeg';
import image3 from '../image/carousel/image3.jpeg';
import image4 from '../image/carousel/image4.jpeg';
import OptionList from '../components/Ui/block/optionList';
import SwiperBlock from '../components/Ui/swiper/swiperBlock';
import Smart from './Smart';
import Dicecell from './Dicecell';
import Xtower from './Xtower';
import tower from '../image/tower.png';

const Tower = () => {
    const [blocks, setBlocks] = useState([
        {id:1, title: 'SMART POLE', linkImg: (linkImg), linkto: '/smart' },
        {id:2, title: 'DICECELL', linkImg: (linkImg), linkto: '/dicecell' },
        {id:3, title: 'X-TOWER', linkImg: (linkImg), linkto: '/xtower' },
    ])
    const [options, setOptions] = useState([
        {id:1, title: 'Технология IoT', src: (iconIot), body: 'Технология IoT - интеграция систем Интернета Вещей', },
        {id:2, title: 'Дизайн', src: (iconDesign), body: 'Архитектурное освещение и уличное освещение пространства вокруг башни', },
        {id:3, title: 'Медиа', src: (iconMedia), body: 'Медиа-панели для организации динамического архитектурного стиля, информирования или демонстрации статической и динамической рекламы', },
        {id:4, title: 'Безопасность', src: (iconSec), body: 'Система безопасности с видеокамерами и средствами обнаружения несанкционированного доступа к башне', },
        {id:5, title: 'Мониторинг', src: (iconMon), body: 'Средства мониторинга метеорологической и экологической обстановки', },
        {id:6, title: 'Контроль', src: (iconControl), body: 'Система инвентаризации и учета ресурсов башни с планшетов и смартфонов по RFID', },
    ])
    
    return (
        <>
            <div className={classes.towerTop}>
                <Container fluid="md">
                    <div className={classes.actContent}>
                        <div className={classes.text}>
                            <h1>АРХИТЕКТУРНЫЕ БАШЕННЫЕ КОНСТРУКЦИИ В УМНОЙ ГОРОДСКОЙ СРЕДЕ</h1>
                            <div className={classes.divider}></div>
                            <p>Объекты городской архитектуры, совмещающие в себе премиальный дизайн и качество исполнения с технологической функциональностью.</p>
                        </div>
                        <img src={tower} alt="img" className={classes.towerImg} />
                    </div>
                </Container>
                <div className={classes.topBg}></div>
            </div>
            <LinkList blocks={blocks} logo={logo} title="Продукты" />
            <OptionList options={options} title="Основные особенности и преимущества " />
            <SwiperBlock img1={image1} img2={image2} img3={image3} img4={image4} />
            <Routes>
                <Route path="/smart" element={<Smart />} />
                <Route path="/dicecell" element={<Dicecell />} />
                <Route path="/xtower" element={<Xtower />} />
            </Routes>
        </>
    )
}

export default Tower; 